import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {environment} from "../../../../../environments/environment";

const apiUrl: string = environment.apiUrl;

export interface ShortLinkCreatePayload {
  long_url: string;
  expires_in_days?: number;
}

export interface ShortLinkResponse {
  short_id: string;
  short_url: string;
  long_url: string;
}

@Injectable({
  providedIn: 'root'
})
export class ShortlinkService {

  constructor(private http: HttpClient) {}

  // Consumir endpoint POST para crear shortlink
  crearShortlink(data): Observable<ShortLinkResponse> {
    return this.http.post<ShortLinkResponse>(`${apiUrl}/mdp/shortlinks/api/shortlinks/`, data);
  }

  // Consumir endpoint GET para resolver shortlink
  resolverShortlink(short_id: string): Observable<ShortLinkResponse> {
    return this.http.get<ShortLinkResponse>(`${apiUrl}/mdp/shortlinks/api/shortlinks/${short_id}/`);
  }

  obtenerShortLink(data): Observable<any>{
    return this.http.post<any>(`${apiUrl}/mdp/shortlinks/api/search/`, data);
  }

  obtenerShortLinkPedido(data): Observable<any>{
    return this.http.post<any>(`${apiUrl}/mdp/shortlinks/api/search/shortlink/`, data);
  }

  obtenerListaShortLinks(data): Observable<any>{
    return this.http.post<any>(`${apiUrl}/mdp/shortlinks/api/list/`, data);
  }

  elimnarShortLink(id): Observable<any>{
    return this.http.delete<any>(`${apiUrl}/mdp/shortlinks/api/delete/${id}/`);
  }
}
